/* import __COLOCATED_TEMPLATE__ from './edit-button.hbs'; */
/** RESPONSIBLE TEAM: team-proactive-support **/
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

interface Args {}

interface Signature {
  Args: Args;
}

export default class EditButton extends Component<Signature> {
  @service declare contentEditorService: any;

  get disabled() {
    return (
      (this.contentEditorService.ruleset.isLive || this.contentEditorService.ruleset.isPaused) &&
      this.contentEditorService.ruleset.isMatchBehaviorStatic
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ContentEditor::Headers::ViewMode::EditButton': typeof EditButton;
    'content-editor/headers/view-mode/edit-button': typeof EditButton;
  }
}
